let benefit_schedule_en = `
<!DOCTYPE html
      PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml">

<head>
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
      <title>VHIS_Standard_Plan_-_Benefit_Schedule_(EN)</title>
      <style type="text/css">
            * {
                  margin: 0;
                  padding: 0;
                  text-indent: 0;
            }

            h1 {
                  color: black;
                  font-family: Arial, sans-serif;
                  font-style: normal;
                  font-weight: bold;
                  text-decoration: none;
                  font-size: 10pt;
            }

            .s1 {
                  color: black;
                  font-family: Arial, sans-serif;
                  font-style: normal;
                  font-weight: bold;
                  text-decoration: none;
                  font-size: 10pt;
            }

            .s2 {
                  color: black;
                  font-family: Arial, sans-serif;
                  font-style: normal;
                  font-weight: bold;
                  text-decoration: none;
                  font-size: 10pt;
                  vertical-align: 3pt;
            }

            .s3 {
                  color: black;
                  font-family: Arial, sans-serif;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 10pt;
            }

            .s4 {
                  color: black;
                  font-family: Arial, sans-serif;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 10pt;
                  vertical-align: 3pt;
            }

            .s5 {
                  color: black;
                  font-family: Arial, sans-serif;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 10pt;
                  vertical-align: -3pt;
            }

            .s6 {
                  color: black;
                  font-family: Arial, sans-serif;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 10pt;
            }

            p {
                  color: black;
                  font-family: Arial, sans-serif;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 10pt;
                  margin: 0pt;
            }

            .s7 {
                  color: black;
                  font-family: Arial, sans-serif;
                  font-style: italic;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 10pt;
            }

            .s8 {
                  color: black;
                  font-family: "Times New Roman", serif;
                  font-style: italic;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 10pt;
            }

            li {
                  display: block;
            }

            #l1 {
                  padding-left: 0pt;
                  counter-reset: c1 1;
            }

            #l1>li:before {
                  counter-increment: c1;
                  content: "("counter(c1, decimal)") ";
                  color: black;
                  font-family: Arial, sans-serif;
                  font-style: normal;
                  font-weight: normal;
                  text-decoration: none;
                  font-size: 8.5pt;
            }

            #l1>li:first-child:before {
                  counter-increment: c1 0;
            }

            .new-page {
              page-break-before: always;
            }

      </style>
</head>

<body>
      
      <h1 style="margin-top: 50pt;text-indent: 10pt;line-height: 140%;text-align: center;">Asia Unique –
            Family <br /> Care Standard Plan Benefit Schedule</h1>
      <p style="text-indent: 0pt;text-align: left;"><br /></p>
      <table style="border-collapse:collapse; margin-left:auto; margin-right:auto;" cellspacing="0">
            <tr style="height:17pt">
                  <td style="width:157pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt;"
                        bgcolor="#A7A8A7">
                        <p class="s1" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: left;">
                              Benefit
                              items<span class="s2">(1)</span></p>
                  </td>
                  <td style="width:312pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                        bgcolor="#A7A8A7">
                        <p class="s1" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">Benefit limit (in
                              [HKD])</p>
                  </td>
            </tr>
            <tr style="height:28pt">
                  <td
                        style="width:157pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">(a) Room and board
                        </p>
                  </td>
                  <td
                        style="width:312pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">$750 per day</p>
                        <p class="s3" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Maximum 180
                              days per Policy Year</p>
                  </td>
            </tr>
            <tr style="height:22pt">
                  <td
                        style="width:157pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">(b) Miscellaneous
                              charges</p>
                  </td>
                  <td
                        style="width:312pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">$14,000 per Policy
                              Year</p>
                  </td>
            </tr>
            <tr style="height:29pt">
                  <td
                        style="width:157pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">(c) Attending
                              doctor&#39;s
                              visit fee</p>
                  </td>
                  <td
                        style="width:312pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">$750 per day</p>
                        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">Maximum 180 days per
                              Policy
                              Year</p>
                  </td>
            </tr>
            <tr style="height:17pt">
                  <td
                        style="width:157pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">(d) Specialist&#39;s
                              fee(2)
                        </p>
                  </td>
                  <td
                        style="width:312pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">$4,300 per Policy
                              Year</p>
                  </td>
            </tr>
            <tr style="height:33pt">
                  <td
                        style="width:157pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">(e) Intensive care
                        </p>
                  </td>
                  <td
                        style="width:312pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">$3,500 per day</p>
                        <p class="s3" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Maximum 25
                              days per Policy Year</p>
                  </td>
            </tr>
            <tr style="height:77pt">
                  <td
                        style="width:157pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">(f) Surgeon&#39;s fee
                        </p>
                  </td>
                  <td
                        style="width:312pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;line-height: 106%;text-align: left;">Per
                              surgery, subject to surgical category for the surgery/procedure in the Schedule of
                              Surgical
                              Procedures –</p>
                        <p class="s3" style="padding-left: 21pt;text-indent: 0pt;line-height: 10pt;text-align: left;">
                              Complex
                              $50,000</p>
                        <p class="s3" style="padding-left: 21pt;text-indent: 0pt;text-align: left;">Major $25,000</p>
                        <p class="s3" style="padding-left: 21pt;text-indent: 0pt;text-align: left;">Intermediate $12,500
                        </p>
                        <p class="s3" style="padding-left: 21pt;text-indent: 0pt;text-align: left;">Minor $5,000</p>
                  </td>
            </tr>
            <tr style="height:17pt">
                  <td
                        style="width:157pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 7pt;text-indent: 0pt;text-align: left;">(g)
                              Anaesthetist&#39;s fee
                        </p>
                  </td>
                  <td
                        style="width:312pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: left;">35%
                              of
                              Surgeon&#39;s fee payable <span class="s4">(5)</span></p>
                  </td>
            </tr>
            <tr style="height:17pt">
                  <td
                        style="width:157pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 7pt;text-indent: 0pt;text-align: left;">(h) Operating theatre
                              charges
                        </p>
                  </td>
                  <td
                        style="width:312pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;line-height: 11pt;text-align: left;">35%
                              of
                              Surgeon&#39;s fee payable <span class="s4">(5)</span></p>
                  </td>
            </tr>
            <tr style="height:29pt">
                  <td
                        style="width:157pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 21pt;text-indent: -14pt;text-align: left;">(i) Prescribed
                              Diagnostic
                              Imaging<span class="s5"> Tests</span><span class="s6">(2) (3)</span></p>
                  </td>
                  <td
                        style="width:312pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-left: 5pt;padding-right: 182pt;text-indent: 0pt;line-height: 106%;text-align: left;">
                              $20,000 per Policy Year Subject to 30% Coinsurance</p>
                  </td>
            </tr>
            <tr style="height:33pt">
                  <td
                        style="width:157pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 21pt;text-indent: -14pt;text-align: left;">(j) Prescribed
                              Non-surgical Cancer Treatments<span class="s4">(4)</span></p>
                  </td>
                  <td
                        style="width:312pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">$80,000 per Policy
                              Year</p>
                  </td>
            </tr>
            <tr style="height:77pt">
                  <td
                        style="width:157pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-left: 21pt;padding-right: 8pt;text-indent: -14pt;line-height: 106%;text-align: left;">
                              (k) Pre- and post-Confinement/Day Case Procedure outpatient care(2)</p>
                  </td>
                  <td
                        style="width:312pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">$580 per visit, up to
                              $3,000
                              per Policy Year</p>
                        <p class="s3"
                              style="padding-top: 1pt;padding-left: 21pt;padding-right: 4pt;text-indent: 0pt;line-height: 108%;text-align: justify;">
                              1 prior outpatient visit or Emergency consultation per Confinement/Day Case Procedure</p>
                        <p class="s3"
                              style="padding-left: 21pt;padding-right: 4pt;text-indent: 0pt;line-height: 107%;text-align: justify;">
                              3 follow-up outpatient visits per Confinement/Day Case Procedure (within 90 days after
                              discharge
                              from Hospital or completion of Day Case Procedure)</p>
                  </td>
            </tr>
            <tr style="height:22pt">
                  <td
                        style="width:157pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 7pt;text-indent: 0pt;text-align: left;">(l) Psychiatric
                              treatments
                        </p>
                  </td>
                  <td
                        style="width:312pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">$30,000 per Policy
                              Year</p>
                  </td>
            </tr>
            <tr style="height:17pt">
                  <td style="width:469pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                        colspan="2">
                        <p class="s1" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Other limits
                        </p>
                  </td>
            </tr>
            <tr style="height:28pt">
                  <td
                        style="width:157pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-left: 5pt;padding-right: 8pt;text-indent: 0pt;line-height: 106%;text-align: left;">
                              Annual Benefit Limit for benefit items (a) – (l)</p>
                  </td>
                  <td
                        style="width:312pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">$420,000 per Policy
                              Year</p>
                  </td>
            </tr>
            <tr style="height:28pt">
                  <td
                        style="width:157pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">Lifetime Benefit
                              Limit for
                              benefit items</p>
                        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">(a) – (l)</p>
                  </td>
                  <td
                        style="width:312pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">Nil</p>
                  </td>
            </tr>
      </table>

      <table style="width: 650px; margin-left: auto; margin-right: auto;">
            <tr>
                  <td>
                        <p style="text-indent: 0pt;text-align: left;"><br /></p>
                        <p style="padding-left: 7pt; padding-top: 3pt;text-indent: 0pt;text-align: left;">Notes –</p>
                        <ol id="l1">
                              <li style="padding-left: 27pt;text-indent: -21pt;line-height: 106%;text-align: left;">
                                    <p style="display: inline;">Eligible Expenses incurred in respect of the same item
                                          shall not be
                                          recoverable
                                          under more than one benefit item in the table above.</p>
                              </li>
                              <li style="padding-left: 27pt;text-indent: -21pt;line-height: 106%;text-align: left;">
                                    <p style="display: inline;">The Company shall have the right to ask for proof of
                                          recommendation
                                          e.g. written
                                          referral or testifying statement on the claim form by the attending doctor or
                                          Registered
                                          Medical
                                          Practitioner.</p>
                              </li>
                              <li style="padding-left: 27pt;text-indent: -21pt;line-height: 108%;text-align: left;">
                                    <p style="display: inline;">Tests covered here only include computed tomography
                                          (“CT” scan),
                                          magnetic
                                          resonance imaging (“MRI” scan), positron emission tomography (“PET” scan),
                                          PET-CT combined
                                          and PET-MRI
                                          combined.</p>
                              </li>
                              <li style="padding-left: 27pt;text-indent: -21pt;line-height: 106%;text-align: left;">
                                    <p style="display: inline;">Treatments covered here only include radiotherapy,
                                          chemotherapy,
                                          targeted
                                          therapy, immunotherapy and hormonal therapy.</p>
                              </li>
                              <li style="padding-left: 27pt;text-indent: -21pt;line-height: 106%;text-align: left;">
                                    <p style="display: inline;">The percentage here applies to the Surgeon&#39;s fee
                                          actually
                                          payable or the
                                          benefit limit for the Surgeon&#39;s fee according to the surgical
                                          categorisation, whichever
                                          is the
                                          lower.</p>
                              </li>
                        </ol>
                  </td>
            </tr>
      </table>

      <div class="new-page"></div>

      <h1 style="padding-top: 3pt;text-indent: 0pt;text-align: center;">Schedule of Surgical
            Procedures
      </h1>
      <p style="text-indent: 0pt;text-align: left;"><br /></p>
      <table style="border-collapse:collapse;margin-left:auto; margin-right:auto;" cellspacing="0">
            <tr style="height:19pt">
                  <td style="width:425pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                        colspan="2" bgcolor="#C0C0C0">
                        <p class="s1" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Procedure /
                              Surgery</p>
                  </td>
                  <td style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                        bgcolor="#C0C0C0">
                        <p class="s1"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Category</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td style="width:503pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                        colspan="3">
                        <p class="s1" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              ABDOMINAL
                              AND DIGESTIVE SYSTEM</p>
                  </td>
            </tr>
            <tr style="height:31pt">
                  <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                        rowspan="17">
                        <p class="s3"
                              style="padding-left: 5pt;padding-right: 33pt;text-indent: 0pt;line-height: 106%;text-align: left;">
                              Oesophageal / stomach / duodenum</p>
                  </td>
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 5pt;padding-right: 26pt;text-indent: 0pt;line-height: 106%;text-align: left;">
                              Excision of oesophageal lesion / destruction of lesion or tissue of oesophagus, cervical
                              approach
                        </p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p style="text-indent: 0pt;text-align: left;"><br /></p>
                        <p class="s3"
                              style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">Major
                        </p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Highly
                              selective vagotomy</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Major</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Laparoscopic
                              fundoplication</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Major</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Laparoscopic
                              repair of hiatal hernia</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Major</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Oesophagogastroduodenoscopy (OGD) +/- biopsy and/or polypectomy</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Minor</p>
                  </td>
            </tr>
            <tr style="height:17pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">OGD
                              with
                              removal of foreign body</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Minor</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">OGD
                              with
                              ligation / banding of oesophageal/ gastric varices</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Intermediate</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Oesophagectomy</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Complex</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Total
                              oesophagectomy and interposition of intestine</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Complex</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Percutaneous
                              gastrostomy</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Minor</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Permanent
                              gastrostomy / gastroenterostomy</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Major</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Partial
                              gastrectomy +/- jejunal transposition</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Major</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Partial
                              gastrectomy with anastomosis to duodenum / jejunum</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Major</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Partial
                              gastrectomy with anastomosis to oesophagus</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Complex</p>
                  </td>
            </tr>
            <tr style="height:31pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 5pt;padding-right: 26pt;text-indent: 0pt;line-height: 108%;text-align: left;">
                              Proximal gastrectomy / radical gastrectomy / total gastrectomy +/- intestinal
                              interposition</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p style="text-indent: 0pt;text-align: left;"><br /></p>
                        <p class="s3"
                              style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Complex</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Suture of
                              laceration of duodenum / patch repair, duodenal ulcer</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Major</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Vagotomy and
                              / or pyloroplasty</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Major</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                        rowspan="13">
                        <p class="s3"
                              style="padding-left: 5pt;padding-right: 14pt;text-indent: 0pt;line-height: 106%;text-align: left;">
                              Jejunum, ileum and large intestine</p>
                  </td>
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Appendicectomy, open or laparoscopic</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Intermediate</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Anal
                              fissurectomy</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Minor</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Anal
                              fistulotomy / fistulectomy</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Intermediate</p>
                  </td>
            </tr>
            <tr style="height:17pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Incision
                              &amp; drainage of perianal abscess</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Minor</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Delorme
                              operation for repair of prolapsed rectum</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Major</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Colonoscopy
                              +/- biopsy</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Minor</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Colonoscopy
                              with polypectomy</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Minor</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Sigmoidoscopy</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Minor</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Haemorrhoidectomy, internal or external</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Intermediate</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Injection /
                              banding of haemorrhoid</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Minor</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Ileostomy or
                              colostomy</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Major</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Anterior
                              resection of rectum, open or laparoscopic</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Complex</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Abdominoperineal resection, open or laparoscopic</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Complex</p>
                  </td>
            </tr>
      </table>
      
      <div class="new-page"></div>
      

      <table style="text-align: center;">
        <table style="border-collapse:collapse;margin-left:auto; margin-right:auto;" cellspacing="0">
              <tr style="height:19pt">
                    <td style="width:425pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="2" bgcolor="#C0C0C0">
                          <p class="s1" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Procedure /
                                Surgery</p>
                    </td>
                    <td style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          bgcolor="#C0C0C0">
                          <p class="s1"
                                style="padding-top: 1pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Category</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="4">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Colectomy,
                                open or laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Low
                                anterior
                                resection of rectum , open or laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Reduction of
                                volvulus or intussusception</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Resection of
                                small intestine and anastomosis</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="3">
                          <p class="s3" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Biliary
                                tract</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Cholecystectomy, open or laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 1pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Endoscopic
                                retrograde cholangio-pancreatography (ERCP)</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:26pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">ERCP
                                with
                                papilla operation, stone extraction or other associated</p>
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                operation
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 6pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="7">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Liver</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Fine
                                needle
                                aspiration (FNA) biopsy of liver</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Liver
                                transplantation</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 26pt;text-indent: 0pt;line-height: 108%;text-align: left;">
                                Marsupialization of lesion / cyst of liver or drainage of liver abscess, open approach</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 8pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Removal of
                                liver lesion, open or laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Sub-segmentectomy of liver, open or laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Segmentectomy of liver, open or laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Wedge
                                resection of liver, open or laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="3">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Pancreas</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Closed
                                biopsy of pancreatic duct</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision /
                                destruction of lesion of pancreas or pancreatic duct</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Pancreaticoduodenectomy (Whipple&#39;s Operation)</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="6">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Abdominal
                                wall</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Exploratory
                                laparotomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Laparoscopy
                                / peritoneoscopy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Unilateral
                                repair of inguinal hernia, open or laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Bilateral
                                repair of inguinal hernia, open or laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Unilateral
                                herniotomy / herniorrhaphy, open or laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Bilateral
                                herniotomy / herniorrhaphy, open or laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:503pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="3">
                          <p class="s1" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                BRAIN AND
                                NERVOUS SYSTEM</p>
                    </td>
              </tr>
              <tr style="height:16pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="9">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Brain</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Brain biopsy
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 1pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Burr
                                hole(s)
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Craniectomy
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Cranial
                                nerve decompression</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 1pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Irrigation
                                of cerebroventricular shunt</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Maintenance
                                removal of cerebroventricular shunt, including revision</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 26pt;text-indent: 0pt;line-height: 106%;text-align: left;">
                                Creation of ventriculoperitoneal shunt or subcutaneous cerebrospinal fluid reservoir</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">Major
                          </p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Clipping of
                                intracranial aneurysm</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Wrapping of
                                intracranial aneurysm</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
        </table>
      </table>  
      
      <div class="new-page"></div>
      
      
      <table style="text-align: center;">
        <table style="border-collapse:collapse;margin-left:auto; margin-right:auto;" cellspacing="0">
              <tr style="height:19pt">
                    <td style="width:425pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="2" bgcolor="#C0C0C0">
                          <p class="s1" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Procedure /
                                Surgery</p>
                    </td>
                    <td style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          bgcolor="#C0C0C0">
                          <p class="s1"
                                style="padding-top: 1pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Category</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="9">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                arteriovenous malformation, intracranial</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                acoustic neuroma</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                brain tumour or brain abscess</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                cranial nerve tumour</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Radiofrequency thermocoagulation of trigeminal ganglion</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Closed
                                trigeminal rhizotomy using radiofrequency</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Decompression of trigeminal nerve root/ open trigeminal rhizotomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                brain, including lobectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Hemispherectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="5">
                          <p class="s3" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Spine</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Lumbar
                                puncture or cisternal puncture</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Decompression of spinal cord or spinal nerve root</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Cervical
                                sympathectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Thoracoscopic or lumbar sympathectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                intraspinal tumour, extradural or intradural</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:503pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="3">
                          <p class="s1" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                CARDIOVASCULAR SYSTEM</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="13">
                          <p class="s3" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Heart</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Cardiac
                                catheterization</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Coronary
                                artery bypass graft (CABG)</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Cardiac
                                transplantation</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Insertion of
                                cardiac pacemaker</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Pericardiocentesis</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Pericardiotomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:46pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 3pt;padding-left: 5pt;padding-right: 26pt;text-indent: 0pt;line-height: 107%;text-align: left;">
                                Percutaneous transluminal coronary angioplasty (PTCA) and related procedures, including
                                use of
                                laser, stenting, motor-blade, balloon angioplasty, radiofrequency ablation technique, etc.
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">Major
                          </p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 70pt;text-indent: 0pt;line-height: 108%;text-align: left;">
                                Pulmonary valvotomy, Balloon / Transluminal laser / Transluminal radiofrequency</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">Major
                          </p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Percutaneous
                                valvuloplasty</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Balloon
                                aortic / mitral valvotomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Closed heart
                                valvotomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Open
                                heart
                                valvuloplasty</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Valve
                                replacement</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="2">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">Vessels</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Intra-abdominal venous shunt/ spleno-renal shunt / portal-caval shunt</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 70pt;text-indent: 0pt;line-height: 106%;text-align: left;">
                                Resection of abdominal vessels with replacement / anastomosis</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:16pt">
                    <td style="width:503pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="3">
                          <p class="s1" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                ENDOCRINE
                                SYSTEM</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Adrenal
                                Gland</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Unilateral
                                adrenalectomy, laparoscopic or retroperitoneoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
        </table>
      </table>

      <div class="new-page"></div>
      

      <table style="text-align: center;">
        <table style="border-collapse:collapse;margin-left:auto; margin-right:auto;" cellspacing="0">
              <tr style="height:19pt">
                    <td style="width:425pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="2" bgcolor="#C0C0C0">
                          <p class="s1" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Procedure /
                                Surgery</p>
                    </td>
                    <td style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          bgcolor="#C0C0C0">
                          <p class="s1"
                                style="padding-top: 1pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Category</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Bilateral
                                adrenalectomy, laparoscopic or retroperitoneoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Pineal gland
                          </p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Total
                                excision of pineal gland</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Pituitary
                                Gland</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Operation of
                                pituitary tumour</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="4">
                          <p class="s3" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Thyroid
                                Gland</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Fine
                                needle
                                aspiration (FNA) of thyroid gland +/- imaging guidance</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 26pt;text-indent: 0pt;line-height: 108%;text-align: left;">
                                Hemithyroidectomy / partial thyroidectomy / subtotal thyroidectomy / parathyroidectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">Major
                          </p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 26pt;text-indent: 0pt;line-height: 106%;text-align: left;">
                                Total thyroidectomy / complete parathyroidectomy / robotic-assisted total thyroidectomy
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">Major
                          </p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                thyroglossal cyst</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:503pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="3">
                          <p class="s1" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">EAR/
                                NOSE /
                                THROAT / RESPIRATORY SYSTEM</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="16">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Ear
                          </p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Canaloplasty
                                for aural atresia / stenosis</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                preauricular cyst / sinus</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Haematoma
                                auris, drainage / buttoning / excision</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Meatoplasty
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Removal of
                                foreign body</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                middle ear tumour via tympanotomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Myringotomy
                                +/- insertion of tube</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Myringoplasty / tympanoplasty</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Ossiculoplasty</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Labyrinthectomy, total / partial excision</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Mastoidectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Operation on
                                cochlea and / or cochlear implant</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Operation on
                                endolymphatic sac / decompression of endolymphatic sac</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Repair of
                                round window or oval window fistula</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Tympanosympathectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Vestibular
                                neurectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:20pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="8">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 24pt;text-indent: 0pt;line-height: 108%;text-align: left;">
                                Nose, mouth and pharynx</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 3pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Antral
                                puncture and lavage</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 3pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Cauterization of nasal mucosa / control of epistaxis</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Closed
                                reduction for fracture nasal bone</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Closure of
                                oro-antral fistula</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Dacryocystorhinostomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                lesion of nose</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">
                                Nasopharyngoscopy / rhinoscopy +/- including rhinoscopic biopsy +/- removal of foreign
                                body</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">Minor
                          </p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Polypectomy
                                of nose</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
        </table>
      </table>

      <div class="new-page"></div>
      

      <table style="text-align: center;">
        <table style="border-collapse:collapse;margin-left: auto; margin-right: auto;" cellspacing="0">
              <tr style="height:19pt">
                    <td style="width:425pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="2" bgcolor="#C0C0C0">
                          <p class="s1" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Procedure /
                                Surgery</p>
                    </td>
                    <td style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          bgcolor="#C0C0C0">
                          <p class="s1"
                                style="padding-top: 1pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Category</p>
                    </td>
              </tr>
              <tr style="height:26pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="26">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Caldwell-Luc
                                operation / Maxillary sinusectomy with Caldwell-Luc</p>
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                approach</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 6pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:26pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Endoscopic
                                sinus surgery on ethmoid / maxillary / frontal / sphenoid</p>
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                sinuses</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 6pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 26pt;text-indent: 0pt;line-height: 106%;text-align: left;">
                                Extended endoscopic frontal sinus surgery with trans-septal frontal sinusotomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 8pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Frontal
                                sinusotomy or ethmoidectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Frontal
                                sinusectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Functional
                                endoscopic sinus surgery (FESS)</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Functional
                                endoscopic sinus surgery (FESS) bilateral</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Maxillary /
                                sphenopalatine / ethmoid artery ligation</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 26pt;text-indent: 0pt;line-height: 108%;text-align: left;">
                                Other intranasal operation, including use of laser (excluding simple rhinoscopy, biopsy
                                and
                                cauterisation of vessel)</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 8pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Rhinoplasty
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Resection of
                                nasopharyngeal tumour</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Sinoscopy
                                +/- biopsy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Septoplasty
                                +/- submucous resection of septum</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Submucous
                                resection of nasal septum</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Turbinectomy
                                / submucous turbinectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Adenoidectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Tonsillectomy +/- adenoidectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                pharyngeal pouch / diverticulum</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Pharyngoplasty</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:51pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-left: 5pt;padding-right: 70pt;text-indent: 0pt;line-height: 110%;text-align: left;">
                                Sleep related breathing disorder – hyoid suspension, maxilla / mandible / tongue
                                advancement, laser
                                suspension / resection, radiofrequency ablation assisted uvulopalatopharyngoplasty,
                                uvulopalatopharyngoplasty</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Marsupialization / excision of ranula</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Parotid
                                gland removal, superficial</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Parotid
                                gland removal / parotidectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Removal of
                                submandibular salivary gland</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Submandibular duct relocation</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Submandibular gland excision</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="4">
                          <p class="s3" style="padding-top: 3pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Respiratory
                                system</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Arytenoid
                                subluxation – laryngoscopic reduction</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Bronchoscopy
                                +/- biopsy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Bronchoscopy
                                with foreign body removal</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Laryngoscopy
                                +/- biopsy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
        </table>
      </table>

      <div class="new-page"></div>
      

      <table style="text-align: center;">
        <table style="border-collapse:collapse;margin-left: auto; margin-right: auto;" cellspacing="0">
              <tr style="height:19pt">
                    <td style="width:425pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="2" bgcolor="#C0C0C0">
                          <p class="s1" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Procedure /
                                Surgery</p>
                    </td>
                    <td style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          bgcolor="#C0C0C0">
                          <p class="s1"
                                style="padding-top: 1pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Category</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="19">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 26pt;text-indent: 0pt;line-height: 106%;text-align: left;">
                                Laryngeal / tracheal stenosis – endolaryngeal / open operation with stenting /
                                reconstruction</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 8pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Laryngeal
                                diversion</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Laryngectomy
                                +/- radical neck resection</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:26pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Microlaryngoscopy +/- Biopsy +/- excision of nodule / polyp / Reinke&#39;s</p>
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                edema</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 6pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Partial /
                                total resection of laryngeal tumour</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Removal of
                                vallecular cyst</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Repair of
                                laryngeal fracture</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Injection
                                for vocal cord paralysis</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Tracheoesophageal puncture for voice rehabilitation</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Thyroplasty
                                for vocal cord paralysis</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Vocal cord
                                operation, including use of laser (excluding carcinoma)</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Tracheostomy, temporary / permanent / revision</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Lobectomy of
                                lung / pneumonectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Pleurectomy
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Segmental
                                resection of lung</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Thoracocentesis / insertion of chest tube for pneumothorax</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Thoracoscopy
                                +/- biopsy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Thoracoplasty</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Thymectomy
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td style="width:503pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="3">
                          <p class="s1" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">EYE
                          </p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="13">
                          <p class="s3" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Eye
                          </p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision /
                                curettage / cryotherapy of lesion of eyelid</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Blepharorrhaphy / tarsorrhaphy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Repair of
                                entropion or ectropion +/- wedge resection</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Reconstruction of eyelid, partial-thickness</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision /
                                destruction of lesion of conjunctiva</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                pterygium</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 41pt;text-indent: 0pt;line-height: 108%;text-align: left;">
                                Corneal grafting, severe wound repair and keratoplasty, including corneal transplant</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">Major
                          </p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Laser
                                removal / destruction of corneal lesion</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Removal of
                                corneal foreign body</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Repair of
                                cornea</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Suture /
                                repair of corneal laceration or wound with conjunctival flap</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Aspiration
                                of lens</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Capsulotomy
                                of lens, including use of laser</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
        </table>
      </table>

      <div class="new-page"></div>
      

      <table style="text-align: center;">
        <table style="border-collapse:collapse;margin-left: auto; margin-right: auto;" cellspacing="0">
              <tr style="height:19pt">
                    <td style="width:425pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="2" bgcolor="#C0C0C0">
                          <p class="s1" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Procedure /
                                Surgery</p>
                    </td>
                    <td style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          bgcolor="#C0C0C0">
                          <p class="s1"
                                style="padding-top: 1pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Category</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="34">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Extracapsular / intracapsular extraction of lens</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Intraocular
                                lens / explant removal</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Chorioretinal lesion operations</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Phacoemulsification and implant of intraocular lens</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Pneumatic
                                retinopexy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Retinal
                                Photocoagulation</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Repair of
                                retinal detachment / tear</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Repair of
                                retinal tear / detachment with buckle</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Scleral
                                buckling / encircling of retinal detachment</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Cyclodialysis</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Trabeculectomy, including use of laser</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Surgical
                                treatment for glaucoma including insertion of implant</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Diagnostic
                                aspiration of vitreous</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Injection of
                                vitreous substitute</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Mechanical
                                vitrectomy / removal of vitreous</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Biopsy of
                                iris</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                lesion of iris / anterior segment of eye / ciliary body</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                prolapsed iris</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Iridotomy
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Iridectomy
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Iridoplasty
                                +/- coreoplasty by laser</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Iridencleisis and iridotasis</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Scleral
                                fistulization +/- iridectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Thermocauterization of sclera +/- iridectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Diminution
                                of ciliary body</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Biopsy of
                                extraocular muscle or tendon</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Operation on
                                one extraocular muscle</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 16pt;text-indent: 0pt;line-height: 108%;text-align: left;">
                                Eyeball, perforating wound of, with incarceration or prolapse of uveal tissue repair</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">Major
                          </p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Enucleation
                                of eye</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Evisceration
                                of eyeball / ocular contents</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Repair of
                                eyeball or orbit</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Conjunctivocystorhinostomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Conjunctivorhinostomy with insertion of tube / stent</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Dacryocystorhinostomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
        </table>
      </table>

      <div class="new-page"></div>
      

      <table style="text-align: center;">
        <table style="border-collapse:collapse;margin-left: auto; margin-right: auto;" cellspacing="0">
              <tr style="height:19pt">
                    <td style="width:425pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="2" bgcolor="#C0C0C0">
                          <p class="s1" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Procedure /
                                Surgery</p>
                    </td>
                    <td style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          bgcolor="#C0C0C0">
                          <p class="s1"
                                style="padding-top: 1pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Category</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="5">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                lacrimal sac and passage</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                lacrimal gland / dacryoadenectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Probing +/-
                                syringing of lacrimal canaliculi / nasolacrimal duct</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Repair of
                                canaliculus</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Coreoplasty
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:503pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="3">
                          <p class="s1" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                FEMALE
                                GENITAL SYSTEM</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="10">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Cervix</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Amputation
                                of cervix</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Colposcopy
                                +/- biopsy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Conization
                                of cervix</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 4pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Destruction
                                of lesion of cervix by excision/ cryosurgery / cauterization</p>
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">/
                                laser</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 8pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Endocervical
                                curettage</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Loop
                                electrosurgical excision procedure (LEEP)</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Marsupialization of cervical cyst</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Repair of
                                cervix</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Repair of
                                fistula of cervix</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Suture of
                                laceration of cervix / uterus / vagina</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="14">
                          <p class="s3"
                                style="padding-left: 5pt;padding-right: 14pt;text-indent: 0pt;line-height: 108%;text-align: left;">
                                Fallopian tubes and ovaries^</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Dilatation /
                                insufflation of fallopian tube</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision /
                                destruction of lesion of fallopian tube, open or laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Repair of
                                fallopian tube</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Salpingostomy / salpingotomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Total or
                                partial salpingectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Tuboplasty
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Aspiration
                                of ovarian cyst</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Ovarian
                                cystectomy, open or laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Wedge
                                resection of ovary, open or laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Oophorectomy
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Oophorectomy, laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Salpingo-oophorectomy, open or laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Drainage of
                                tubo-ovarian abscess, open or laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:26pt">
                    <td style="width:404pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="2">
                          <p class="s7" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">^
                                The
                                category applies to both unilateral and bilateral procedures unless otherwise</p>
                          <p class="s7" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                specified.
                          </p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="3">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Uterus</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Dilatation
                                and curettage of Uterine (D&amp;C)</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Hysteroscopy
                                +/- biopsy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 70pt;text-indent: 0pt;line-height: 108%;text-align: left;">
                                Hysteroscopy with excision or destruction of uterus and supporting structures</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
        </table>
      </table>

      <div class="new-page"></div>
      

      <table style="text-align: center;">
        <table style="border-collapse:collapse;margin-left: auto; margin-right: auto;" cellspacing="0">
              <tr style="height:19pt">
                    <td style="width:425pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="2" bgcolor="#C0C0C0">
                          <p class="s1" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Procedure /
                                Surgery</p>
                    </td>
                    <td style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          bgcolor="#C0C0C0">
                          <p class="s1"
                                style="padding-top: 1pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Category</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="12">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Hysterotomy
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Laparoscopic
                                assisted vaginal hysterectomy (LAVH)</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Vaginal
                                hysterectomy +/- repair of cystocele and/or rectocele</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 26pt;text-indent: 0pt;line-height: 108%;text-align: left;">
                                Total / subtotal abdominal hysterectomy +/- bilateral salpingo- oophorectomy, open or
                                laparoscopic
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">Major
                          </p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Radical
                                abdominal hysterectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Myomectomy,
                                open or laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Uterine
                                myomectomy, vaginal or hysteroscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Laparoscopic
                                drainage of female pelvic abscess</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Colposuspension</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Pelvic floor
                                repair</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Pelvic
                                exenteration</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Uterine
                                suspension</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="21">
                          <p class="s3" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Vagina</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 70pt;text-indent: 0pt;line-height: 106%;text-align: left;">
                                Destruction of lesion of vagina by excision / cryosurgery / cauterization / laser</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">Minor
                          </p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Insertion /
                                removal of vaginal supportive pessaries</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Marsupialization of Bartholin&#39;s cyst</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Vaginal
                                stripping of vaginal cuff</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Vaginotomy
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Partial
                                vaginectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Vaginectomy,
                                complete</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:20pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 3pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Radical
                                vaginectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 3pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Anterior
                                colporrhaphy +/- Kelly plication</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Posterior
                                colporrhaphy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Obliteration
                                of vaginal vault</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Sacrospinous
                                ligament suspension or fixation of the vagina</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Sacral
                                colpopexy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Vaginal
                                repair of enterocoele</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Closure of
                                urethro-vaginal fistula</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Repair of
                                rectovaginal fistula, vaginal approach</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Repair of
                                rectovaginal fistula, abdominal approach</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Culdocentesis</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Culdotomy
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                transverse vaginal septum</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                McCall&#39;s
                                culdeplasty / culdoplasty</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
        </table>
      </table>

      <div class="new-page"></div>
      

      <table style="text-align: center;">
        <table style="border-collapse:collapse;margin-left: auto; margin-right: auto;" cellspacing="0">
              <tr style="height:19pt">
                    <td style="width:425pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="2" bgcolor="#C0C0C0">
                          <p class="s1" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Procedure /
                                Surgery</p>
                    </td>
                    <td style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          bgcolor="#C0C0C0">
                          <p class="s1"
                                style="padding-top: 1pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Category</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Vaginal
                                reconstruction</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="10">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">Vulva and introitus
                          </p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Destruction
                                of lesion of vulva by excision / cryosurgery / cauterization</p>
                          <p class="s3" style="padding-left: 5pt;text-indent: 0pt;text-align: left;">/ laser</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">Minor
                          </p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Wide
                                local
                                excision of vulva with cold knife or LEEP</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                vestibular adenitis</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision
                                biopsy of vulva</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Incision and
                                drainage of vulva and perineum</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Lysis of
                                vulvar adhesions</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Repair of
                                fistula of vulva or perineum</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Suture of
                                lacerations / repair of vulva and/or perineum</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Vulvectomy
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Radical
                                vulvectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:503pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="3">
                          <p class="s1" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                HEMIC AND
                                LYMPHATIC SYSTEM</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="11">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Lymph Nodes
                          </p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Drainage of
                                lesion / abscess of lymph node</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 41pt;text-indent: 0pt;line-height: 106%;text-align: left;">
                                Biopsy / excision of superficial lymph nodes / simple excision of lymphatic structure</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">Minor
                          </p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;line-height: 106%;text-align: left;">
                                Incisional biopsy of cervical lymph node / fine needle aspiration (FNA) biopsy of lymph
                                nodes</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">Minor
                          </p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                deep lymph node / lymphangioma / cystic hygroma</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Bilateral
                                inguinal lymphadenectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Cervical
                                lymphadenectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Inguinal and
                                pelvic lymphadenectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Radical
                                groin dissection</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Radical
                                pelvic lymphadenectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Selective /
                                radical / functional neck dissection</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Wide
                                excision of axillary lymph node</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Spleen</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Splenectomy,
                                open or laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:503pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="3">
                          <p class="s1" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">MALE
                                GENITAL
                                SYSTEM</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="8">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Prostate</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                External
                                drainage of prostatic abscess</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Photoselective vaporization of prostate</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Plasma
                                vaporization of prostate</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Prostate
                                biopsy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Transurethral microwave therapy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Transurethral prostatectomy or TURP</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Prostatectomy, open or laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Radical
                                prostatectomy, open or laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
        </table>
      </table>

      <div class="new-page"></div>
      

      <table style="text-align: center;">
        <table style="border-collapse:collapse;margin-left: auto; margin-right: auto;" cellspacing="0">
              <tr style="height:19pt">
                    <td style="width:425pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="2" bgcolor="#C0C0C0">
                          <p class="s1" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Procedure /
                                Surgery</p>
                    </td>
                    <td style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          bgcolor="#C0C0C0">
                          <p class="s1"
                                style="padding-top: 1pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Category</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="3">
                          <p class="s3" style="padding-top: 7pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Penis</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Circumcision
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Release of
                                chordee</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Repair of
                                buried / avulsion of penis</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="12">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Testicles^
                          </p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Epididymectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Exploration
                                of testis</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Exploration
                                for undescended testis, laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Orchidopexy
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Orchidectomy
                                or orchidopexy, laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Reduction of
                                torsion of testis and fixation</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Testicular
                                biopsy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">High
                                ligation of hydrocoele</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Tapping of
                                hydrocele</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                varicocoele and hydrocoele of spermatic cord</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Varicocelectomy (microsurgical)</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:26pt">
                    <td style="width:404pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="2">
                          <p class="s7"
                                style="padding-left: 5pt;padding-right: 35pt;text-indent: 0pt;line-height: 12pt;text-align: left;">
                                ^
                                The category applies to both unilateral and bilateral procedures unless otherwise
                                specified.</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Spermatic
                                cord</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Vasectomy
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:503pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="3">
                          <p class="s1" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                MUSCULOSKELETAL SYSTEM</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="12">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Bone
                          </p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Amputation
                                of finger(s) / toe(s) of one limb</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Amputation
                                of one arm / hand / leg / foot</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Bunionectomy
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 26pt;text-indent: 0pt;line-height: 108%;text-align: left;">
                                Bunionectomy with soft tissue correction and osteotomy of the first metatarsal</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">Major
                          </p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                radial head</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Mandibulectomy for benign disease</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Patellectomy
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Partial
                                ostectomy of facial bone</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Sequestrectomy of facial bone</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Wedge
                                osteotomy of bone of wrist / hand / leg</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Wedge
                                osteotomy of bone of upper arm / lower arm / thigh</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Wedge
                                osteotomy of scapula / clavicle / sternum</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="5">
                          <p class="s3" style="padding-top: 5pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Joint</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Arthroscopic
                                drainage and debridement</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Arthroscopic
                                removal of loose body from joints</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Arthroscopic
                                examination of joint +/- biopsy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Arthroscopic
                                assisted ligament reconstruction</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Arthroscopic
                                Bankart repair</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
        </table>
      </table>

      <div class="new-page"></div>
      

      <table style="text-align: center;">
        <table style="border-collapse:collapse;margin-left: auto; margin-right: auto;" cellspacing="0">
              <tr style="height:19pt">
                    <td style="width:425pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="2" bgcolor="#C0C0C0">
                          <p class="s1" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Procedure /
                                Surgery</p>
                    </td>
                    <td style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          bgcolor="#C0C0C0">
                          <p class="s1"
                                style="padding-top: 1pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Category</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="28">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Arthroscopic
                                repair for superior labral tear from anterior to posterior of shoulder</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 8pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Arthroscopic
                                rotator cuff repair</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Acromioplasty</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Arthrodesis
                                of shoulder</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Arthrodesis
                                of Elbow / Triple arthrodesis</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Arthrodesis
                                of knee / hip</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Arthroplasty
                                of hand / finger / foot / Toe joint with implant</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Fusion of
                                wrist</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Synovectomy
                                of wrist</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Interphalangeal joint fusion of toes</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Interphalangeal fusion of finger</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excisional
                                arthroplasty shoulder / hemiarthroplasty of shoulder</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excisional
                                arthroplasty of hip / knee / Wrist / Elbow</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excisional
                                arthroplasty of hip / knee with local antibiotic delivery</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Temporomandibular arthroplasty +/- autograft</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Joint
                                aspiration / injection</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Manipulation
                                of joint under anesthesia</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Metal
                                femoral head insertion</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Anterior
                                cruciate ligament reconstruction</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Meniscectomy, open or arthroscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Posterior
                                cruciate ligament reconstruction</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Repair of
                                the collateral ligaments</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Repair of
                                the cruciate ligaments</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Suture of
                                capsule or ligament of ankle and foot</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Total
                                shoulder replacement</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Total knee
                                replacement</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Total hip
                                replacement</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Partial hip
                                replacement</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="5">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Muscle/
                                Tendon</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Achilles
                                tendon repair</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Achillotenotomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Change in
                                muscle or tendon length (except hand) / excision of lesion of muscle</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 8pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Change in
                                muscle or tendon length of hand</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                lesion of muscle</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
        </table>
      </table>

      <div class="new-page"></div>
      

      <table style="text-align: center;">
        <table style="border-collapse:collapse;margin-left: auto; margin-right: auto;" cellspacing="0">
              <tr style="height:19pt">
                    <td style="width:425pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="2" bgcolor="#C0C0C0">
                          <p class="s1" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Procedure /
                                Surgery</p>
                    </td>
                    <td style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          bgcolor="#C0C0C0">
                          <p class="s1"
                                style="padding-top: 1pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Category</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="11">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Lengthening
                                of tendon, including tenotomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Open
                                biopsy
                                of muscle</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Release of
                                De Quervain&#39;s disease</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Release of
                                trigger finger</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Release of
                                tennis elbow</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Transfer /
                                transplantation / reattachment of muscle</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Tendon
                                repair / Suture of tendon not involving hand</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Tendon
                                repair / Suture of tendon of hand</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Tenosynovectomy / synovectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Transposition of tendon of wrist / hand</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Secondary
                                repair of tendon, including graft, transfer and / or prosthesis</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="16">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 49pt;text-indent: 0pt;line-height: 106%;text-align: left;">
                                Fracture/ dislocation</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 70pt;text-indent: 0pt;line-height: 106%;text-align: left;">
                                Closed reduction of dislocation of temporomandibular / interphalangeal / acromioclavicular
                                joint</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 8pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:23pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 4pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Closed
                                reduction of dislocation of shoulder / elbow / wrist / ankle</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 4pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Closed
                                reduction for Colles&#39; fracture with percutaneous k-wire fixation</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:26pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Closed
                                reduction for fracture of arm / leg / patella / pelvis with internal</p>
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                fixation</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 6pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Close
                                reduction for mandibular fracture with internal fixation</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">
                                Closed reduction for fracture of clavicle / scapula / phalanges / patella without internal
                                fixation
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">Minor
                          </p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 26pt;text-indent: 0pt;line-height: 108%;text-align: left;">
                                Closed reduction for fracture of upper arm / lower arm / wrist / hand / leg / foot bone
                                without
                                internal fixation</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 8pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 26pt;text-indent: 0pt;line-height: 108%;text-align: left;">
                                Closed reduction for fracture of clavicle / hand / ankle /foot with internal fixation</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Closed
                                reduction for fracture of femur +/- internal fixation</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Closed /
                                open reduction of fracture of acetabulum with internal fixation</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Open
                                reduction for mandibular fracture with internal fixation</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 70pt;text-indent: 0pt;line-height: 106%;text-align: left;">
                                Open reduction for clavicle / hand / foot (except carpal / talus / calcaneus) +/- internal
                                fixation
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Open
                                reduction for arm / leg / patella / scapula +/- internal fixation</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Open
                                reduction for femur / calcaneus / talus/ +/- internal fixation</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 26pt;text-indent: 0pt;line-height: 108%;text-align: left;">
                                Operative treatment of compound fracture with external fixator and extensive wound
                                debridement</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 8pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 26pt;text-indent: 0pt;line-height: 108%;text-align: left;">
                                Removal of screw, pin and plate, and other metal for old fracture except fracture femur
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">Minor
                          </p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Spine</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Artificial
                                cervical disc replacement</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
        </table>
      </table>

      <div class="new-page"></div>
      

      <table style="text-align: center;">
        <table style="border-collapse:collapse;margin-left: auto; margin-right: auto;" cellspacing="0">
              <tr style="height:19pt">
                    <td style="width:425pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="2" bgcolor="#C0C0C0">
                          <p class="s1" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Procedure /
                                Surgery</p>
                    </td>
                    <td style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          bgcolor="#C0C0C0">
                          <p class="s1"
                                style="padding-top: 1pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Category</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="13">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Anterior
                                spinal fusion, cervical / cervicothoracic/ C4/5 and C5/6 and locking plate</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 8pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;line-height: 108%;text-align: left;">
                                Anterior spinal fusion (excluding cervical / cervicothoracic/ C4/5 and C5/6 and locking
                                plate)</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Anterior
                                spinal fusion with instrumentation</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Laminoplasty
                                for cervical spine</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Laminectomy
                                / diskectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Laminectomy
                                with diskectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 16pt;text-indent: 0pt;line-height: 108%;text-align: left;">
                                Posterior spinal fusion, thoracic / cervico-thoracic / thoracolumbar / T5 to L1/
                                atlas-axis</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">Major
                          </p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 26pt;text-indent: 0pt;line-height: 108%;text-align: left;">
                                Posterior spinal fusion, (excluding thoracic / cervico-thoracic / thoracolumbar / T5 to L1
                                /
                                atlas-axis)</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Posterior
                                spinal fusion with instrumentation</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Spinal
                                biopsy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Spinal
                                fusion +/- foraminotomy +/- laminectomy +/- diskectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Spine
                                osteotomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Vertebroplasty / kyphoplasty</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="7">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Others</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                ganglion / bursa</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Closed/
                                Percutaneous needle fasciotomy for Dupuytren disease</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Radical (or
                                total) fasciectomy for Dupuytren disease</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Release of
                                carpal / tarsal tunnel, open or endoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Release of
                                peripheral nerve</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Transposition of ulnar nerve</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Sliding /
                                reduction genioplasty</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:503pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="3">
                          <p class="s1" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">SKIN
                                AND
                                BREAST</p>
                    </td>
              </tr>
              <tr style="height:26pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="9">
                          <p class="s3" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Skin
                          </p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-left: 5pt;padding-right: 41pt;text-indent: 0pt;line-height: 12pt;text-align: left;">
                                Curettage / cryotherapy / cauterization / laser treatment of lesion of skin</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 6pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Drainage of
                                subungual haematoma or abscess</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                lipoma</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                skin for graft</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Incision and
                                /or drainage of skin abscess</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:26pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-left: 5pt;padding-right: 41pt;text-indent: 0pt;line-height: 12pt;text-align: left;">
                                Incision and /or removal of foreign body from skin and subcutaneous tissue</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 6pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:31pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 5pt;padding-right: 70pt;text-indent: 0pt;line-height: 106%;text-align: left;">
                                Local excision or destruction of lesion or tissue of skin and subcutaneous tissue</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                          <p class="s3"
                                style="padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">Minor
                          </p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Suture of
                                wound on skin</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Surgical
                                toilet and suturing</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
        </table>
      </table>

      <div class="new-page"></div>
      

      <table style="text-align: center;">
        <table style="border-collapse:collapse;margin-left: auto; margin-right: auto;" cellspacing="0">
              <tr style="height:19pt">
                    <td style="width:425pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="2" bgcolor="#C0C0C0">
                          <p class="s1" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Procedure /
                                Surgery</p>
                    </td>
                    <td style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          bgcolor="#C0C0C0">
                          <p class="s1"
                                style="padding-top: 1pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Category</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p style="text-indent: 0pt;text-align: left;"><br /></p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Wedge
                                resection of toenail</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="9">
                          <p class="s3" style="padding-top: 7pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Breast</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Breast
                                tumour/ lump excision +/- biopsy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Fine
                                needle
                                aspiration (FNA) of breast cyst</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Incisional
                                breast biopsy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Modified
                                radical mastectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Partial or
                                simple mastectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Partial or
                                radical mastectomy with axillary lymphadenectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Total or
                                radical mastectomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Duct
                                papilloma excision</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Gynaecomastia excision</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:503pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          colspan="3">
                          <p class="s1" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                URINARY
                                SYSTEM</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="8">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Kidney</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Extracorporeal shock wave lithotripsy for urinary stone (ESWL)</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Nephrolithotomy / pyelolithotomy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Nephroscopy
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Percutaneous
                                insertion of nephrostomy tube</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Renal biopsy
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Nephrectomy,
                                open or laparoscopic or retroperitoneoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Nephrectomy,
                                partial/ lower pole</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Kidney
                                transplant</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                          rowspan="15">
                          <p class="s3"
                                style="padding-left: 5pt;padding-right: 15pt;text-indent: 0pt;line-height: 106%;text-align: left;">
                                Bladder, ureter and urethra</p>
                    </td>
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Cystoscopy
                                +/- biopsy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:26pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Cystoscopy
                                with catheterization of ureter/ transurethral bladder</p>
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                clearance
                          </p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 6pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Cystoscopy
                                with electro-cauterisation/ laser lithotripsy</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Excision of
                                urethra caruncle</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Minor</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Insertion of
                                urethral/ureter stent</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Intermediate</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Diverticulectomy of urinary bladder, open or laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:17pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Transurethral resection of bladder tumour</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Partial
                                cystectomy, open or laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Radical/
                                total cystectomy, open or laparoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Complex</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Ureterolithotomy, open or laparoscopic or retroperitoneoscopic</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Closure of
                                urethro-rectal fistula</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Repair of
                                urethral fistula</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Repair of
                                vesicovaginal fistula</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Repair of
                                vesicocolic fistula</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
              <tr style="height:18pt">
                    <td
                          style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                                Repair of
                                rupture of urethra</p>
                    </td>
                    <td
                          style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                          <p class="s3"
                                style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                                Major</p>
                    </td>
              </tr>
        </table>
      </table>
      
      <div class="new-page"></div>
      

      <table style="text-align: center;">
      <table style="border-collapse:collapse;margin-left:auto; margin-right:auto;" cellspacing="0">
            <tr style="height:19pt">
                  <td style="width:425pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                        colspan="2" bgcolor="#C0C0C0">
                        <p class="s1" style="padding-top: 1pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Procedure /
                              Surgery</p>
                  </td>
                  <td style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                        bgcolor="#C0C0C0">
                        <p class="s1"
                              style="padding-top: 1pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Category</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                        rowspan="5">
                        <p style="text-indent: 0pt;text-align: left;"><br /></p>
                  </td>
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Repair of
                              urinary stress incontinence</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Major</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Formation of
                              ileal conduit, including ureteric implantation</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Complex</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Ileal or
                              colonic replacement of ureter</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Major</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Unilateral
                              reimplantation of ureter into bowel or bladder</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Major</p>
                  </td>
            </tr>
            <tr style="height:17pt">
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              Bilateral
                              reimplantation of ureter into bowel or bladder</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Major</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td style="width:503pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                        colspan="3">
                        <p class="s1" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">
                              DENTAL</p>
                  </td>
            </tr>
            <tr style="height:18pt">
                  <td
                        style="width:99pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p style="text-indent: 0pt;text-align: left;"><br /></p>
                  </td>
                  <td
                        style="width:326pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3" style="padding-top: 2pt;padding-left: 5pt;text-indent: 0pt;text-align: left;">Any
                              kind of
                              dental surgery due to injury caused by an Accident</p>
                  </td>
                  <td
                        style="width:78pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                        <p class="s3"
                              style="padding-top: 2pt;padding-left: 13pt;padding-right: 12pt;text-indent: 0pt;text-align: center;">
                              Minor</p>
                  </td>
            </tr>
      </table>
    </table>
      <p style="text-indent: 0pt;text-align: center;"><br /></p>
</body>

</html>
`

export { benefit_schedule_en }
